<template>

  <!-- <div v-bind:style="{display:tabledata.length>0?'block':'none'}" > -->
  <div v-if="tabledata.length > 0 || Object.keys(matchrule || {}).length != 0">
    <p style="font-weight:bold;font-size:1.5em">{{ tabletitle }}</p>

    <vuetable ref="vuetable" :fields="tablefields" :api-mode="false" :data="tabledata"
      :css="{ tableClass: 'table table-sm table-hover' }" @vuetable:cell-clicked="actioncellclick"
      no-data-template="暂无数据">
      <span slot="sq" slot-scope="props">{{ props.rowIndex + 1 }}</span>
      <!-- <el-button type="text" slot="status" slot-scope="props"> -->
      <status slot="status" slot-scope="props" :rowData="props.rowData" :rowField="props.rowField"></status>
      <!-- </el-button> -->

      <template v-if="ifheaderoperate" slot="tableHeader" slot-scope="props">
        <tableheader :props="props" :sortsetdefault="sortset || {}" :matchruledefault="matchrule || {}"
          @headersetdone="headersetdone"></tableheader>
        <!-- <VuetableRowHeader></VuetableRowHeader> -->
      </template>

    </vuetable>
    <el-row v-if="iffootermore">
      <el-col :span="12"><el-button type="text" @click="checkmore">查看更多More....</el-button></el-col>
      <el-col :span="12"><el-button type="text" @click="jumpto">跳转goto</el-button></el-col>
    </el-row>
    <!-- <div style="margin-bottom:50px;background-color:rgba(0,0,0,0.2)" v-if="tabledata.length===0">
      <p style="font-size=2em;font-weight:bold">无数据</p>
    </div> -->
    <hr style="width:100%;text-align:left;margin-left:0">
  </div>

</template>

<script>
import Vuetable from "vuetable-2";
// import { fields } from "../presentation/vuetablefields.js";
// import {formatter} from "../presentation/utility/formatter"
import { fieldsprocess } from "zxg-table-fieldsprocess";
import status from "@/components/utility/commonfields/status";
import tableheader from "@/components/presentation/table/table_header";


export default {
  components: {
    Vuetable,
    tableheader,
    status
  },
  props: ["collection", "tabletitle", "thedata", "ifheaderoperate", "iffootermore", "sortset", "matchrule", "searchval"],
  data() {
    return {
      pages: 1,
      processing: false,
      tabledata: this.thedata.doc || []
    };
  },
  mounted() {

  },

  computed: {
    // tabledata(){
    //   return this.thedata.doc||[]
    // },
    tablefields() {
      return this.extendedfields(this.thedata.fields)
    }
  },

  methods: {
    extendedfields(fields) {
      let tablefields = JSON.parse(JSON.stringify(fields));
      tablefields.unshift({ name: "sq", title: "序列" });
      tablefields = fieldsprocess(tablefields, "pure", this.$store);
      return tablefields;
    },
    headersetdone(obj) {

      this.$emit("headersetdone", obj)
    },
    actioncellclick(obj) {
      // console.log(obj)
      // if (this.$router.currentRoute.path == "/" && this.caller!='hyperlink') {
      this.$message("clicked");
      // }

      let singledata = JSON.parse(JSON.stringify(obj))
      this.$emit("cilckfromsigleclct", singledata)
    },
    jumpto() {
      this.$store.commit("settargettxt", this.searchval)
      let objcollection = this.$store.state.collections.find(obj => { return obj.value === this.collection })
      this.$router.push("/")
      this.$parent.$parent.$parent.showpopover = false
      this.$nextTick(() => {
        this.$axios.jumptoclct({ collection: objcollection, model: "generalsearch", value: this.searchval || this.$store.state.targettxt })
      })
    },
    checkmore() {

      this.pages = this.pages + 1
      this.$axios
        .post(url + "aggregateclct", {
          collections: [this.collection],
          value: this.searchval,
          pages: this.pages,
          matchrule: this.matchrule,
          sortset: this.sortset
        })
        .then(res => {
          this.tabledata = this.tabledata.concat(res.data[this.collection].doc)
          // console.log(res.data)
        });

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/news/singleclct.vue